import router from "../../router";

const leftovers = {
  namespaced: true,
  state: {
    selected: null,
    cell: null,
    item: {
      products: [],
    },
  },
  mutations: {
    setSelected(state, payload) {
      state.selected = payload;
    },
    setItem(state, payload) {
      if (null === payload) {
        state.item = {
          products: [],
        };
        return;
      }

      state.item = {
        ...payload,
        products: payload.products.map((product) => {
          product.cells = [];

          product.images = {
            small: [
              "https://img.gepur.com/products/" +
                Math.ceil(product.article / 5000) * 5000 +
                `/` +
                product.article +
                "/simple/388/" +
                product.article +
                "_1.jpg",
              "https://img.gepur.com/products/" +
                Math.ceil(product.article / 5000) * 5000 +
                `/` +
                product.article +
                "/simple/388/" +
                product.article +
                "_2.jpg",
              "https://img.gepur.com/products/" +
                Math.ceil(product.article / 5000) * 5000 +
                `/` +
                product.article +
                "/simple/388/" +
                product.article +
                "_3.jpg",
            ],
            big: [
              "https://img.gepur.com/products/" +
                Math.ceil(product.article / 5000) * 5000 +
                `/` +
                product.article +
                "/simple/origins/" +
                product.article +
                "_1.jpg",
              "https://img.gepur.com/products/" +
                Math.ceil(product.article / 5000) * 5000 +
                `/` +
                product.article +
                "/simple/origins/" +
                product.article +
                "_2.jpg",
              "https://img.gepur.com/products/" +
                Math.ceil(product.article / 5000) * 5000 +
                `/` +
                product.article +
                "/simple/origins/" +
                product.article +
                "_3.jpg",
            ],
          };

          return product;
        }),
      };

      if (payload.products.length > 0) {
        this.commit("leftovers/setSelected", state.item.products[0]);
      } else {
        this.commit("leftovers/setSelected", null);
      }

      this.commit("leftovers/setCell", null);

      this.commit("messages/setMessage", {
        type: "info",
        code: "Ой ли!",
        message: "Выгружен новый список товаров по остаткам",
      });

      router.push({ name: "leftovers" });
    },
    updateProductItem(state, payload) {
      let product = state.item.products.find(
        (product) =>
          String(product.size) === String(payload.size) &&
          parseInt(product.article) === parseInt(payload.article)
      );

      if (!product) {
        product = {
          article: payload.article,
          size: payload.size,
          id_1c: payload.article,
          name: payload.article,
          provider: payload.provider,
          provider_name: payload.provider_name,
          status: payload.status,
          quantity: 0,
          cells: [],
          images: {
            small: [
              "https://img.gepur.com/products/" +
                Math.ceil(payload.article / 5000) * 5000 +
                `/` +
                payload.article +
                "/simple/388/" +
                payload.article +
                "_1.jpg",
              "https://img.gepur.com/products/" +
                Math.ceil(payload.article / 5000) * 5000 +
                `/` +
                payload.article +
                "/simple/388/" +
                payload.article +
                "_2.jpg",
              "https://img.gepur.com/products/" +
                Math.ceil(payload.article / 5000) * 5000 +
                `/` +
                payload.article +
                "/simple/388/" +
                payload.article +
                "_3.jpg",
            ],
            big: [
              "https://img.gepur.com/products/" +
                Math.ceil(payload.article / 5000) * 5000 +
                `/` +
                payload.article +
                "/simple/origins/" +
                payload.article +
                "_1.jpg",
              "https://img.gepur.com/products/" +
                Math.ceil(payload.article / 5000) * 5000 +
                `/` +
                payload.article +
                "/simple/origins/" +
                payload.article +
                "_2.jpg",
              "https://img.gepur.com/products/" +
                Math.ceil(payload.article / 5000) * 5000 +
                `/` +
                payload.article +
                "/simple/origins/" +
                payload.article +
                "_3.jpg",
            ],
          },
        };

        state.item.products.push(product);
      }

      const existsProductCell = product.cells.find(
        (cell) => cell.id === payload.cell.id
      );

      if (null === existsProductCell) {
        product.cells.push(payload.cell);
      }

      product.quantity = product.quantity + 1;

      this.commit("leftovers/setSelected", product);

      this.commit("messages/setMessage", {
        type: "info",
        code: "Остатки!",
        message: "Товар " + product.article + " обновлен.",
      });

      router.push({ name: "leftovers" });
    },
    setCell(state, payload) {
      if (null === payload) {
        state.cell = payload;
        return;
      }

      state.cell = payload;

      this.commit("messages/setMessage", {
        type: "info",
        code: "Остатки!",
        message: `Выбрана ячейка: "${payload.message}"`,
      });

      router.push({ name: "leftovers" });
    },
  },
  actions: {},
  getters: {},
};

export default leftovers;
